/**
 * Shared labels, tones and the open event for help queries, used by the
 * floating panel and the Changelog page.
 */

import type { AuthUser } from "@/lib/api/auth";
import type { QueryStatus } from "@/lib/api/support";
import type { Tone } from "@/primitives/surface";

/** Any screen can open the help panel: `{ detail: { queryId } }` opens a
 *  thread, no detail opens a new query. With LoopDesk connected a query is
 *  named by its number instead (`{ detail: { number: "DT-012" } }`). */
export const OPEN_SUPPORT_EVENT = "drtutor:open-support";

export function openSupport(query?: number | string): void {
  const detail = typeof query === "string" ? { number: query } : query ? { queryId: query } : undefined;
  window.dispatchEvent(new CustomEvent(OPEN_SUPPORT_EVENT, { detail }));
}

export const STATUS_TONE: Record<QueryStatus, Tone> = {
  open: "accent",
  in_progress: "warning",
  resolved: "success",
  closed: "neutral",
};

export const ROLE_LABEL: Record<string, string> = {
  admin: "Admin",
  tutor: "Tutor",
  student: "Student",
  parent: "Parent",
};

/** Our LoopDesk team answers queries and is the only one who moves their status. */
export function isLoopDeskTeam(user: AuthUser | null | undefined): boolean {
  return Boolean(user?.is_loopdesk_team);
}

/** The LoopDesk team and DrTutor admins see every query; admins read only. */
export function seesAllQueries(user: AuthUser | null | undefined): boolean {
  return isLoopDeskTeam(user) || user?.role === "admin";
}
